module.exports = __webpack_public_path__ + "static/media/pousada_6.66dabe5a.jpg";